package one.healthium.today.ui.carni.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.relocation.BringIntoViewRequester
import androidx.compose.foundation.relocation.bringIntoViewRequester
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.em
import loco.TODAY_LOG_FOOD_BUTTON
import one.healthium.health_advice.ui.message.HealthAdviceMessage
import one.healthium.today.ui.TodayUiState
import one.healthium.today.ui.components.TodayUserProfile
import one.healthium.ui.compose.components.AppButton
import one.healthium.ui.compose.components.AppButtonDefaults
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.compose.theme.brown_2
import one.healthium.ui.compose.theme.white
import org.jetbrains.compose.resources.stringResource
import androidx.compose.ui.tooling.preview.Preview

@Composable
internal fun Header(
    state: TodayUiState,
    onAddFoodClicked: () -> Unit,
    onLogSymptomsClicked: () -> Unit,
) {
    val bringIntoViewRequester = remember { BringIntoViewRequester() }

    CompositionLocalProvider(LocalContentColor provides white) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .background(brown_2, headerShape)
                .bringIntoViewRequester(bringIntoViewRequester),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Box(Modifier.statusBarsPadding())
            val userProfile = state.userProfile
            if (userProfile != null) {
                TodayUserProfile(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(horizontal = 24.dp)
                        .padding(top = 12.dp),
                    userProfile = userProfile,
                )
            }
            Spacer(Modifier.height(4.dp))
            HealthAdviceMessage(
                modifier = Modifier.fillMaxWidth(),
                bringIntoViewRequester = bringIntoViewRequester,
                onLogSymptomsClicked = onLogSymptomsClicked,
                style = AppTheme.textStyles.secondary_17_400,
                lineHeight = 1.5.em,
                textAlign = TextAlign.Start,
            )
            Spacer(Modifier.height(8.dp))
            CaloriesCounter(
                model = state.todayCaloriesCounter,
            )
            Spacer(Modifier.height(24.dp))
            AppButton(
                modifier = Modifier.testTag("log_food_button"),
                onClick = onAddFoodClicked,
                colors = AppButtonDefaults.secondaryButtonColors,
            ) {
                Text(stringResource(loco.Res.string.TODAY_LOG_FOOD_BUTTON))
            }
            Spacer(Modifier.height(24.dp))
        }
    }
}

@Composable
@Preview(showBackground = true)
private fun HeaderPreview() {
    AppTheme {
        Header(
            state = TodayUiState.preview,
            onAddFoodClicked = {},
            onLogSymptomsClicked = {},
        )
    }
}